import { Currency } from "@evennt-tech/api-v2-core";

const locales = {
  aed: "en-ae",
  gbp: "en-US",
  eur: "en-EU",
  aud: "en-US",
  usd: "en-US",
};

const formatPrice = (price = 0, currency: Currency = Currency.gbp): string => {
  const locale = locales[currency];

  return (+price).toLocaleString(locale, {
    style: "currency",
    currency: currency.toLocaleLowerCase(),
  });
};

export const getCurrencySymbol = (currency: Currency = Currency.gbp) => {
  const locale = locales[currency];
  const formattedZero = "0.00";
  const currencySymbol = (0)
    .toLocaleString(locale, {
      style: "currency",
      currency: currency.toLocaleLowerCase(),
    })
    .split(formattedZero)[0]
    .trim();
  return currencySymbol;
};

export default formatPrice;
